<template>
    <div class="card-body">
        <div class="form">
            <div class="col-12">
                <label for="imagen">Imagen cabecera pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X287 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_base_cabecera_url">
                    <img :src="manager.imagen_base_cabecera_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_base_cabecera')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="287"
                        :width="2182"
                        @success="imagenSubida('imagen_base_cabecera', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen publicidad pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 500X290 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_base_publicidad_url">
                    <img :src="manager.imagen_base_publicidad_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_base_publicidad')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="290"
                        :width="500"
                        @success="imagenSubida('imagen_base_publicidad', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <label for="imagen">Imagen patrocinadores pdf:</label>
                <p>
                    <small>
                        MEDIDAS: 2182X319 - FORMATO: JPG - PESO MÁXIMO: Menos de 500 KB
                        <br/>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <template v-if="manager.imagen_base_patrocinadores_url">
                    <img :src="manager.imagen_base_patrocinadores_url" style="max-height: 300px"/>
                    <br/>
                    <Button class="mt-1" @click="imagenBorrada('imagen_base_patrocinadores')">Borrar</Button>
                </template>
                <template v-else>
                    <Dropzone 
                        v-if="url"
                        :url="url"
                        :height="319"
                        :width="2182"
                        @success="imagenSubida('imagen_base_patrocinadores', ...arguments)"
                    />
                </template>
            </div>
            <hr/>
            <div class="col-12">
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';
    
    export default {
        props: ['manager'],
        data() {
            return {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                managerLocal: this.manager 
            }
        },
        methods: {
            guardarOpciones() {
                this.$emit('guardar', this.managerLocal);
            },
            imagenBorrada(campo) {
                switch (campo) {
                    case 'imagen_base_patrocinadores':
                        this.managerLocal.imagen_base_patrocinadores = null;
                        this.managerLocal.imagen_base_patrocinadores_url = null;
                        break;
                    case 'imagen_base_cabecera':
                        this.managerLocal.imagen_base_cabecera = null;
                        this.managerLocal.imagen_base_cabecera_url = null;
                        break;
                    case 'imagen_base_publicidad':
                        this.managerLocal.imagen_base_publicidad = null;
                        this.managerLocal.imagen_base_publicidad_url = null;  
                        break;
                }
            },
            imagenSubida(campo, file, response) {
                switch (campo) {
                    case 'imagen_base_patrocinadores':
                        this.managerLocal.imagen_base_patrocinadores = response;
                        break;
                    case 'imagen_base_cabecera':
                        this.managerLocal.imagen_base_cabecera = response;
                        break;
                    case 'imagen_base_publicidad':
                        this.managerLocal.imagen_base_publicidad = response;
                        break;
                }
            }
        },
        components: {
            Dropzone
        }
    }
</script>
